(() => {
  const routes = JSON.parse(document.getElementById("rose-routes")?.textContent || "{}");

  const menuButton = document.querySelector("[data-menu-toggle]");
  const menu = document.querySelector("[data-mobile-nav]");
  const searchButton = document.querySelector("[data-search-toggle]");
  const searchPanel = document.querySelector("[data-search-panel]");
  const searchInput = document.querySelector("[data-search-input]");
  const searchResults = document.querySelector("[data-search-results]");
  const searchEmpty = document.querySelector("[data-search-empty]");
  const filtersToggle = document.querySelector("[data-filters-toggle]");
  const filtersPanel = document.querySelector("[data-filters-panel]");

  function setOpen(button, panel, open) {
    if (!button || !panel) return;
    window.clearTimeout(panel._closeTimer);
    button.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      panel.hidden = false;
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => panel.classList.add("is-open"));
      });
      return;
    }
    panel.classList.remove("is-open");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    panel._closeTimer = window.setTimeout(() => {
      if (button.getAttribute("aria-expanded") === "false") panel.hidden = true;
    }, reduce ? 0 : 440);
  }

  menuButton?.addEventListener("click", () => {
    const open = menuButton.getAttribute("aria-expanded") !== "true";
    setOpen(searchButton, searchPanel, false);
    setOpen(menuButton, menu, open);
  });

  searchButton?.addEventListener("click", () => {
    const open = searchButton.getAttribute("aria-expanded") !== "true";
    setOpen(menuButton, menu, false);
    setOpen(searchButton, searchPanel, open);
    if (open) searchInput?.focus();
  });

  const siteHeader = document.querySelector("[data-site-header]");
  function syncHeaderShadow() {
    siteHeader?.classList.toggle("is-scrolled", window.scrollY > 8);
  }
  syncHeaderShadow();
  window.addEventListener("scroll", syncHeaderShadow, { passive: true });

  filtersToggle?.addEventListener("click", () => {
    const open = filtersPanel?.classList.toggle("is-open");
    filtersToggle.setAttribute("aria-expanded", open ? "true" : "false");
  });

  let searchTimer = 0;
  searchInput?.addEventListener("input", () => {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(runSearch, 180);
  });

  async function runSearch() {
    if (!searchResults || !routes.search) return;
    const query = searchInput.value.trim();
    searchResults.replaceChildren();
    if (searchEmpty) searchEmpty.hidden = true;
    if (query.length < 1) return;

    const url = new URL(routes.search, window.location.origin);
    url.searchParams.set("q", query);
    url.searchParams.set("resources[type]", "product");
    url.searchParams.set("resources[limit]", "8");
    const response = await fetch(url);
    if (!response.ok) return;
    const data = await response.json();
    const products = data?.resources?.results?.products || [];
    if (products.length === 0) {
      if (searchEmpty) searchEmpty.hidden = false;
      return;
    }

    for (const product of products) {
      const item = document.createElement("li");
      const link = document.createElement("a");
      link.href = product.url;
      const imageUrl = product.image || product.featured_image?.url;
      if (imageUrl) {
        const image = document.createElement("img");
        image.src = imageUrl;
        image.alt = "";
        image.width = 48;
        image.height = 60;
        link.append(image);
      }
      link.append(document.createTextNode(product.title));
      item.append(link);
      searchResults.append(item);
    }
  }

  const drawer = document.querySelector("[data-cart-drawer]");

  async function refreshCart(open) {
    if (!drawer) return;
    const sectionId = drawer.dataset.sectionId;
    const response = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
    if (!response.ok) return;
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const next = parsed.querySelector("[data-cart-drawer]");
    if (!next) return;
    const wasOpen = drawer.open;
    drawer.innerHTML = next.innerHTML;
    const count = next.dataset.count || "0";
    document.querySelectorAll("[data-cart-count]").forEach((node) => {
      const changed = node.textContent.trim() !== String(count);
      node.textContent = count;
      node.hidden = count === "0";
      if (changed && count !== "0") {
        node.classList.remove("is-bump");
        void node.offsetWidth;
        node.classList.add("is-bump");
      }
    });
    bindDrawer();
    if (open || wasOpen) drawer.showModal();
  }

  function recipientRoot(node) {
    return node?.closest("[data-cart-page], [data-cart-drawer]") || document;
  }

  const MONTHS = { Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06", Jul: "07", Aug: "08", Sep: "09", Sept: "09", Oct: "10", Nov: "11", Dec: "12" };

  const GIFT_LINES = [
    { category: "romance", text: "Just because you crossed my mind, and I wanted to remind you how much I adore you." },
    { category: "romance", text: "Every day with you is brighter than the last. These are just a small token of my big love." },
    { category: "romance", text: "To my favorite person: I love you more today than yesterday, but less than tomorrow." },
    { category: "romance", text: "Distance means so little when someone means so much. Thinking of you always." },
    { category: "romance", text: "You are my sunshine on cloudy days and my favorite reason to smile." },
    { category: "birthday", text: "Wishing you a year filled with as much happiness, laughter, and love as you bring to everyone else. Happy Birthday!" },
    { category: "birthday", text: "May this year bring you wonderful new adventures and sweet surprises. Happy Birthday!" },
    { category: "birthday", text: "Cheers to another fabulous year around the sun! Hope your day is as beautiful as these blooms." },
    { category: "birthday", text: "Sending you the happiest of birthday wishes and a bouquet to brighten your special day!" },
    { category: "thanks", text: "I couldn't have gotten through this without your incredible support. Thank you from the bottom of my heart." },
    { category: "thanks", text: "A small token of my deep appreciation for everything you do. You're the best!" },
    { category: "thanks", text: "Thank you for always being my rock and for bringing so much joy into my life." },
    { category: "comfort", text: "Sending you a little extra sunshine and strength while you rest and recover. Get well soon!" },
    { category: "comfort", text: "Thinking of you during this difficult time. Wishing you peace, comfort, and a speedy recovery." },
    { category: "comfort", text: "May these bright blooms bring a little cheer to your day and remind you that I’m rooting for you." },
    { category: "congrats", text: "So proud of your incredible achievement! All your hard work finally paid off—time to celebrate!" },
    { category: "congrats", text: "Wishing you huge congratulations on this exciting new chapter! The best is yet to come." },
    { category: "congrats", text: "You did it! Thrilled to see all your dreams and goals turning into reality." },
    { category: "friendship", text: "Life is so much sweeter and more fun with a friend like you in it. Sending love!" },
    { category: "friendship", text: "No special occasion needed—just wanted to remind you how much you are cherished." },
  ];

  const giftShown = new WeakMap();

  function shuffleLines(lines) {
    const copy = [...lines];
    for (let index = copy.length - 1; index > 0; index -= 1) {
      const swap = Math.floor(Math.random() * (index + 1));
      [copy[index], copy[swap]] = [copy[swap], copy[index]];
    }
    return copy;
  }

  function drawGiftLines(previous) {
    const pool = shuffleLines(GIFT_LINES.filter((line) => !previous.has(line.text)));
    const picked = [];
    const categories = new Set();
    pool.forEach((line) => {
      if (picked.length === 4 || categories.has(line.category)) return;
      picked.push(line);
      categories.add(line.category);
    });
    pool.forEach((line) => {
      if (picked.length === 4 || picked.includes(line)) return;
      picked.push(line);
    });
    return picked;
  }

  function renderGiftSuggestions(fields) {
    const list = fields.querySelector("[data-gift-list]");
    const root = fields.querySelector("[data-gift-suggestions]");
    if (!list || !root) return;
    const labels = root.dataset;
    const previous = giftShown.get(fields) || new Set();
    const lines = drawGiftLines(previous);
    giftShown.set(fields, new Set(lines.map((line) => line.text)));
    list.replaceChildren();
    lines.forEach((line) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "gift-suggestion";
      button.dataset.giftSuggestion = line.text;
      const category = document.createElement("span");
      category.className = "gift-suggestion-category";
      category.textContent = labels[line.category] || line.category;
      const text = document.createElement("span");
      text.className = "gift-suggestion-text";
      text.textContent = line.text;
      button.append(category, text);
      list.append(button);
    });
  }

  function dxbNow() {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Dubai",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        hourCycle: "h23",
      })
        .formatToParts(new Date())
        .map((part) => [part.type, part.value])
    );
    return { iso: `${parts.year}-${parts.month}-${parts.day}`, hour: Number(parts.hour) };
  }

  function addDays(iso, days) {
    const [year, month, day] = iso.split("-").map(Number);
    const date = new Date(Date.UTC(year, month - 1, day + days));
    return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}-${String(date.getUTCDate()).padStart(2, "0")}`;
  }

  function englishDate(iso) {
    const [year, month, day] = iso.split("-").map(Number);
    return new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" })
      .format(new Date(Date.UTC(year, month - 1, day)))
      .replace(",", "");
  }

  function isoFromEnglish(label) {
    const match = /^(\d{1,2}) ([A-Za-z]{3,4}) (\d{4})$/.exec(label.trim());
    if (!match || !MONTHS[match[2]]) return "";
    return `${match[3]}-${MONTHS[match[2]]}-${match[1].padStart(2, "0")}`;
  }

  function dateBounds() {
    const now = dxbNow();
    const min = now.hour >= 15 ? addDays(now.iso, 1) : now.iso;
    return { now, min, max: addDays(now.iso, 30) };
  }

  function selectedFlowers(fields) {
    return fields?.querySelector("[data-flowers-for]:checked")?.value || "";
  }

  function selectedDelivery(fields) {
    const radio = fields?.querySelector("[data-delivery-time]:checked");
    if (!radio || radio.disabled) return "";
    return radio.value;
  }

  function writeDate(fields, iso) {
    const hidden = fields.querySelector("[data-delivery-date-value]");
    if (hidden) hidden.value = iso ? englishDate(iso) : "";
    fields.dataset.selectedIso = iso || "";
  }

  function selectedEmirate(fields) {
    return fields?.querySelector("[data-emirate]")?.value || "";
  }

  function applyWindows(fields) {
    const { now } = dateBounds();
    const future = Boolean(fields.dataset.selectedIso) && fields.dataset.selectedIso > now.iso;
    fields.querySelectorAll("[data-delivery-time]").forEach((radio) => {
      const closed = !future && now.hour >= Number(radio.dataset.opens);
      radio.disabled = closed;
      const option = radio.closest(".window-option");
      if (option) option.hidden = closed;
      if (closed && radio.checked) radio.checked = false;
    });
    const windowGroup = fields.querySelector("[data-delivery-window]");
    if (windowGroup) {
      windowGroup.hidden = ![...fields.querySelectorAll("[data-delivery-time]")].some((radio) => !radio.disabled);
    }
  }

  function applyDateBounds(fields) {
    const { now, min, max } = dateBounds();
    const todayRadio = fields.querySelector('[data-date-mode][value="today"]');
    const todayClosed = now.hour >= 15;
    if (todayRadio) {
      todayRadio.disabled = todayClosed;
      const option = todayRadio.closest(".window-option");
      if (option) option.hidden = todayClosed;
      if (todayClosed && todayRadio.checked) todayRadio.checked = false;
    }
    fields.querySelector(".date-options")?.classList.toggle("is-later", todayClosed);
    const input = fields.querySelector("[data-delivery-date-input]");
    if (input) {
      input.min = min;
      input.max = max;
    }
  }

  function syncDateFromMode(fields) {
    applyDateBounds(fields);
    const mode = fields.querySelector("[data-date-mode]:checked")?.value || "";
    const input = fields.querySelector("[data-delivery-date-input]");
    const field = fields.querySelector("[data-date-field]");
    const { now, min, max } = dateBounds();
    setRevealed(field, mode === "pick");
    let iso = "";
    if (mode === "today") iso = now.iso;
    else if (mode === "tomorrow") iso = addDays(now.iso, 1);
    else if (mode === "pick") iso = input?.value || "";
    if (iso && (iso < min || iso > max)) iso = "";
    writeDate(fields, iso);
    applyWindows(fields);
  }

  function restoreDate(fields) {
    const hidden = fields.querySelector("[data-delivery-date-value]");
    const beforeDate = hidden?.value || "";
    const beforeTime = fields.querySelector("[data-delivery-time]:checked")?.value || "";
    const { now, min, max } = dateBounds();
    const todayLabel = englishDate(now.iso);
    const tomorrowLabel = englishDate(addDays(now.iso, 1));
    let mode = "";
    let iso = "";
    if (beforeDate === todayLabel) {
      if (now.hour >= 15) {
        mode = "";
        iso = "";
      } else {
        mode = "today";
        iso = now.iso;
      }
    } else if (beforeDate === tomorrowLabel) {
      mode = "tomorrow";
      iso = addDays(now.iso, 1);
    } else if (beforeDate) {
      iso = isoFromEnglish(beforeDate);
      mode = iso ? "pick" : "";
    }
    if (iso && (iso < min || iso > max)) {
      mode = "";
      iso = "";
    }
    fields.querySelectorAll("[data-date-mode]").forEach((radio) => {
      radio.checked = radio.value === mode;
    });
    const input = fields.querySelector("[data-delivery-date-input]");
    if (input) input.value = mode === "pick" ? iso : "";
    syncDateFromMode(fields);
    return beforeDate !== (hidden?.value || "") || beforeTime !== selectedDelivery(fields);
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function setRevealed(node, open) {
    if (!node) return;
    const gen = String(Number(node.dataset.revealGen || 0) + 1);
    node.dataset.revealGen = gen;
    const current = () => node.dataset.revealGen === gen;
    if (node.dataset.revealTimer) {
      window.clearTimeout(Number(node.dataset.revealTimer));
      delete node.dataset.revealTimer;
    }
    if (open) {
      if (!node.hidden && node.classList.contains("is-open")) {
        if (!node.classList.contains("is-settled")) {
          window.setTimeout(() => {
            if (current() && node.classList.contains("is-open")) node.classList.add("is-settled");
          }, prefersReducedMotion() ? 0 : 680);
        }
        return;
      }
      node.hidden = false;
      node.classList.remove("is-settled");
      node.removeAttribute("aria-hidden");
      const settle = () => {
        if (current() && node.classList.contains("is-open")) node.classList.add("is-settled");
      };
      if (prefersReducedMotion()) {
        node.classList.add("is-open", "is-settled");
        return;
      }
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (!current()) return;
          node.classList.add("is-open");
          window.setTimeout(settle, 680);
        });
      });
      return;
    }
    if (node.hidden) return;
    node.classList.remove("is-settled");
    if (!prefersReducedMotion()) void node.offsetHeight;
    node.classList.remove("is-open");
    node.setAttribute("aria-hidden", "true");
    if (prefersReducedMotion()) {
      node.hidden = true;
      return;
    }
    node.dataset.revealTimer = String(
      window.setTimeout(() => {
        if (!current()) return;
        node.hidden = true;
        delete node.dataset.revealTimer;
      }, 680)
    );
  }

  function playGiftEntrance(fields) {
    fields.querySelectorAll(".gift-suggestion").forEach((button) => {
      button.style.animation = "none";
      void button.offsetWidth;
      button.style.animation = "";
    });
  }

  function toggleSchedule(fields) {
    setRevealed(fields.querySelector("[data-delivery-schedule]"), selectedEmirate(fields) !== "");
  }

  function toggleRecipient(fields, clearValues) {
    const someone = selectedFlowers(fields) === "Someone else";
    const details = fields.querySelector("[data-recipient-details]");
    const wasOpen = Boolean(details && !details.hidden && details.classList.contains("is-open"));
    setRevealed(details, someone);
    if (someone && !wasOpen) playGiftEntrance(fields);
    if (!someone && clearValues) {
      ["[data-recipient-name]", "[data-recipient-phone]", "[data-card-message]"].forEach((selector) => {
        const input = fields.querySelector(selector);
        if (input) input.value = "";
      });
    }
  }

  function syncRecipient(source) {
    const values = readRecipient(source);
    const mode = source.querySelector("[data-date-mode]:checked")?.value || "";
    const sourceDate = source.querySelector("[data-delivery-date-input]");
    document.querySelectorAll("[data-recipient]").forEach((other) => {
      if (other === source) return;
      other.querySelectorAll("[data-flowers-for]").forEach((radio) => {
        radio.checked = values.forWho !== "" && radio.value === values.forWho;
      });
      const nameInput = other.querySelector("[data-recipient-name]");
      const phoneInput = other.querySelector("[data-recipient-phone]");
      const message = other.querySelector("[data-card-message]");
      if (nameInput && document.activeElement !== nameInput) nameInput.value = values.name;
      if (phoneInput && document.activeElement !== phoneInput) phoneInput.value = values.phone;
      if (message && document.activeElement !== message) message.value = values.message;
      const otherEmirate = other.querySelector("[data-emirate]");
      if (otherEmirate && document.activeElement !== otherEmirate) otherEmirate.value = values.emirate;
      setRevealed(other.querySelector("[data-delivery-schedule]"), values.emirate !== "");
      const hidden = other.querySelector("[data-delivery-date-value]");
      if (hidden) hidden.value = values.date;
      other.dataset.selectedIso = source.dataset.selectedIso || "";
      other.querySelectorAll("[data-date-mode]").forEach((radio) => {
        radio.checked = radio.value === mode;
      });
      const otherDate = other.querySelector("[data-delivery-date-input]");
      if (otherDate && sourceDate) otherDate.value = sourceDate.value;
      setRevealed(other.querySelector("[data-date-field]"), mode === "pick");
      applyDateBounds(other);
      applyWindows(other);
      other.querySelectorAll("[data-delivery-time]").forEach((radio) => {
        radio.checked = !radio.disabled && values.time !== "" && radio.value === values.time;
      });
      toggleRecipient(other, false);
    });
  }

  function readRecipient(fields) {
    const forWho = selectedFlowers(fields);
    const someone = forWho === "Someone else";
    return {
      forWho,
      emirate: selectedEmirate(fields),
      date: fields?.querySelector("[data-delivery-date-value]")?.value.trim() || "",
      time: selectedDelivery(fields),
      name: someone ? fields?.querySelector("[data-recipient-name]")?.value.trim() || "" : "",
      phone: someone ? fields?.querySelector("[data-recipient-phone]")?.value.trim() || "" : "",
      message: someone ? fields?.querySelector("[data-card-message]")?.value.trim() || "" : "",
    };
  }

  function recipientHasValues(values) {
    return Boolean(values.forWho || values.emirate || values.date || values.time || values.name || values.phone || values.message);
  }

  let saveChain = Promise.resolve();

  function saveRecipient(root) {
    const task = async () => {
      if (!routes.cartUpdate) return;
      let values = readRecipient(root?.querySelector?.("[data-recipient]"));
      if (!recipientHasValues(values)) {
        document.querySelectorAll("[data-recipient]").forEach((other) => {
          const next = readRecipient(other);
          if (recipientHasValues(next)) values = next;
        });
      }
      if (!root?.querySelector?.("[data-recipient]") && !recipientHasValues(values)) return;
      await fetch(`${routes.cartUpdate}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          attributes: {
            "Flowers for": values.forWho,
            "Delivery emirate": values.emirate,
            "Delivery date": values.date,
            "Delivery time": values.time,
            "Recipient name": values.name,
            "Recipient phone": values.phone,
            "Card message": values.message,
          },
        }),
      });
    };
    saveChain = saveChain.then(task, task);
    return saveChain;
  }

  function bindRecipient(root) {
    root?.querySelectorAll("[data-recipient]").forEach((fields) => {
      if (fields.dataset.bound) return;
      fields.dataset.bound = "true";
      const name = fields.querySelector("[data-recipient-name]");
      const phone = fields.querySelector("[data-recipient-phone]");
      const windows = [...fields.querySelectorAll("[data-delivery-time]")];
      const windowGroup = fields.querySelector("[data-delivery-window]");
      const windowError = fields.querySelector("[data-delivery-error]");
      const flowersGroup = fields.querySelector("[data-flowers]");
      const flowersError = fields.querySelector("[data-flowers-error]");
      const emirateGroup = fields.querySelector("[data-emirate-group]");
      const emirateError = fields.querySelector("[data-emirate-error]");
      const dateGroup = fields.querySelector("[data-delivery-date]");
      const dateError = fields.querySelector("[data-date-error]");
      const clear = (input) => input?.setCustomValidity("");
      const clearGroup = (group, error) => {
        if (error) error.hidden = true;
        group?.removeAttribute("aria-invalid");
      };
      const showGroup = (group, error, focus) => {
        if (error) error.hidden = false;
        group?.setAttribute("aria-invalid", "true");
        focus?.focus();
      };
      const forMe = selectedFlowers(fields) === "Me";
      const staleGift = forMe && Boolean(name?.value || phone?.value || fields.querySelector("[data-card-message]")?.value);
      const dateChanged = restoreDate(fields);
      const savedTime = fields.querySelector("[data-delivery-window]")?.dataset.savedTime || "";
      const knownTime = [...fields.querySelectorAll("[data-delivery-time]")].some((radio) => radio.value === savedTime);
      const staleTime = savedTime !== "" && !knownTime;
      toggleRecipient(fields, forMe);
      toggleSchedule(fields);
      if (dateChanged || staleGift || staleTime) saveRecipient(root);
      renderGiftSuggestions(fields);
      fields.addEventListener("click", (event) => {
        if (event.target.closest("[data-gift-more]")) {
          event.preventDefault();
          renderGiftSuggestions(fields);
          return;
        }
        const suggestion = event.target.closest("[data-gift-suggestion]");
        if (!suggestion) return;
        event.preventDefault();
        const message = fields.querySelector("[data-card-message]");
        if (!message) return;
        message.value = suggestion.dataset.giftSuggestion || "";
        syncRecipient(fields);
        saveRecipient(root);
      });
      fields.addEventListener("input", (event) => {
        clear(name);
        clear(phone);
        if (event.target.matches("[data-delivery-date-input]")) {
          syncDateFromMode(fields);
          clearGroup(dateGroup, dateError);
        }
        syncRecipient(fields);
      });
      fields.addEventListener("change", (event) => {
        const target = event.target;
        if (target.matches("[data-flowers-for]")) {
          toggleRecipient(fields, true);
          clearGroup(flowersGroup, flowersError);
        }
        if (target.matches("[data-emirate]")) {
          toggleSchedule(fields);
          clearGroup(emirateGroup, emirateError);
        }
        if (target.matches("[data-date-mode], [data-delivery-date-input]")) {
          syncDateFromMode(fields);
          clearGroup(dateGroup, dateError);
        }
        if (target.matches("[data-delivery-time]")) clearGroup(windowGroup, windowError);
        if (target.matches("[data-flowers-for], [data-emirate], [data-date-mode], [data-delivery-date-input], [data-delivery-time]")) {
          syncRecipient(fields);
          saveRecipient(root);
        }
      });
      fields.addEventListener("focusout", () => {
        saveRecipient(root);
      });
      const form = fields.closest("form");
      form?.setAttribute("novalidate", "");
      form?.addEventListener("submit", (event) => {
        const values = readRecipient(fields);
        clear(name);
        clear(phone);
        if (!values.forWho || !values.emirate || !values.date || !values.time || (values.forWho === "Someone else" && (!values.name || !values.phone))) {
          event.preventDefault();
          if (!values.forWho) {
            showGroup(flowersGroup, flowersError, fields.querySelector("[data-flowers-for]"));
            return;
          }
          if (!values.emirate) {
            showGroup(emirateGroup, emirateError, fields.querySelector("[data-emirate]"));
            return;
          }
          if (!values.date) {
            const mode = fields.querySelector("[data-date-mode]:checked")?.value;
            showGroup(dateGroup, dateError, mode === "pick" ? fields.querySelector("[data-delivery-date-input]") : fields.querySelector("[data-date-mode]"));
            return;
          }
          if (!values.time) {
            showGroup(windowGroup, windowError, windows.find((radio) => !radio.disabled));
            return;
          }
          if (name) name.setCustomValidity(values.name ? "" : name.dataset.invalid || "");
          if (phone) phone.setCustomValidity(values.phone ? "" : phone.dataset.invalid || "");
          (values.name ? phone : name)?.reportValidity();
        }
      });
    });
  }

  let lineLock = false;

  function lineControl(root, attribute, key) {
    return [...(root?.querySelectorAll(`[${attribute}]`) || [])].find((node) => node.getAttribute(attribute) === key);
  }

  async function changeLine(id, quantity, root) {
    if (lineLock) return;
    lineLock = true;
    root?.querySelectorAll("[data-line-dec], [data-line-inc], [data-line-remove], [data-line-qty]").forEach((node) => {
      node.disabled = true;
    });
    try {
      await saveRecipient(root);
      await fetch(`${routes.cartChange}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id, quantity }),
      });
      if (document.querySelector("[data-cart-page]")) {
        window.location.reload();
        return;
      }
      await refreshCart(true);
    } finally {
      lineLock = false;
      root?.querySelectorAll("[data-line-dec], [data-line-inc], [data-line-remove], [data-line-qty]").forEach((node) => {
        if (!node.isConnected) return;
        if (node.hasAttribute("data-line-dec")) {
          const input = lineControl(root, "data-line-qty", node.getAttribute("data-line-dec"));
          node.disabled = Number(input?.value || 1) <= 1;
          return;
        }
        node.disabled = false;
      });
    }
  }

  function bindLines(root) {
    root?.querySelectorAll("[data-line-qty]").forEach((input) => {
      input.addEventListener("change", () => {
        const quantity = Number(input.value);
        if (!Number.isFinite(quantity)) return;
        changeLine(input.dataset.lineQty, Math.max(0, quantity), recipientRoot(input));
      });
    });
    root?.querySelectorAll("[data-line-dec]").forEach((button) => {
      button.addEventListener("click", () => {
        const key = button.dataset.lineDec;
        const input = lineControl(root, "data-line-qty", key);
        const current = Number(input?.value || 1);
        if (current <= 1) return;
        const quantity = current - 1;
        if (input) input.value = String(quantity);
        button.disabled = quantity <= 1;
        changeLine(key, quantity, recipientRoot(button));
      });
    });
    root?.querySelectorAll("[data-line-inc]").forEach((button) => {
      button.addEventListener("click", () => {
        const key = button.dataset.lineInc;
        const input = lineControl(root, "data-line-qty", key);
        const quantity = Number(input?.value || 0) + 1;
        if (input) input.value = String(quantity);
        const dec = lineControl(root, "data-line-dec", key);
        if (dec) dec.disabled = quantity <= 1;
        changeLine(key, quantity, recipientRoot(button));
      });
    });
    root?.querySelectorAll("[data-line-remove]").forEach((button) => {
      button.addEventListener("click", () => changeLine(button.dataset.lineRemove, 0, recipientRoot(button)));
    });
    bindRecipient(root);
  }

  function bindDrawer() {
    drawer?.querySelectorAll("[data-cart-close]").forEach((button) => {
      button.addEventListener("click", () => drawer.close());
    });
    bindLines(drawer);
  }

  bindDrawer();
  bindLines(document.querySelector("[data-cart-page]"));

  document.querySelectorAll("[data-cart-open]").forEach((button) => {
    button.addEventListener("click", () => {
      setOpen(menuButton, menu, false);
      setOpen(searchButton, searchPanel, false);
      drawer?.showModal();
    });
  });

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-add-to-cart]");
    if (!button || !routes.cartAdd) return;
    event.preventDefault();
    const id = button.dataset.variantId;
    if (!id) return;
    button.disabled = true;
    try {
      const response = await fetch(`${routes.cartAdd}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: Number(id), quantity: Number(button.dataset.quantity || 1) }),
      });
      if (!response.ok) return;
      await refreshCart(true);
    } finally {
      button.disabled = false;
    }
  });

  document.querySelectorAll("form.product-form").forEach((form) => {
    const idInput = form.querySelector("[name='id']");
    const price = form.querySelector("[data-price]");
    const qty = form.querySelector("[data-qty]");
    form.querySelectorAll("[data-variant]").forEach((choice) => {
      choice.addEventListener("click", () => {
        form.querySelectorAll("[data-variant]").forEach((item) => {
          item.setAttribute("aria-pressed", item === choice ? "true" : "false");
        });
        if (idInput) idInput.value = choice.dataset.variant;
        if (price) price.textContent = choice.dataset.price;
      });
    });
    form.querySelector("[data-qty-dec]")?.addEventListener("click", () => {
      if (!qty) return;
      qty.value = String(Math.max(1, Number(qty.value || 1) - 1));
    });
    form.querySelector("[data-qty-inc]")?.addEventListener("click", () => {
      if (!qty) return;
      qty.value = String(Number(qty.value || 1) + 1);
    });
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const submit = form.querySelector("[type='submit']");
      if (submit) submit.disabled = true;
      try {
        const response = await fetch(`${routes.cartAdd}.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            id: Number(idInput?.value),
            quantity: Math.max(1, Number(qty?.value || 1)),
          }),
        });
        if (!response.ok) return;
        const added = form.querySelector("[data-added]");
        if (added) added.hidden = false;
        await refreshCart(true);
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  });

  document.querySelectorAll("[data-media]").forEach((button) => {
    button.addEventListener("click", () => {
      const image = document.querySelector("[data-main-image]");
      document.querySelectorAll("[data-media]").forEach((item) => {
        item.setAttribute("aria-pressed", item === button ? "true" : "false");
      });
      if (!image || !button.dataset.media) return;
      image.src = button.dataset.media;
      image.removeAttribute("srcset");
    });
  });

  document.querySelectorAll("[data-tab]").forEach((button) => {
    button.addEventListener("click", () => {
      const name = button.dataset.tab;
      document.querySelectorAll("[data-tab]").forEach((item) => {
        const selected = item.dataset.tab === name;
        item.setAttribute("aria-selected", selected ? "true" : "false");
      });
      document.querySelectorAll("[data-tab-panel]").forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== name;
      });
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    setOpen(menuButton, menu, false);
    setOpen(searchButton, searchPanel, false);
  });
})();
